export const menu = [{
  name: 'Gft Demo',
  description: 'REACT DEMO',
  target: 'React, Csharp Net7.0 Web API',
  programId: 'BM7599',
  image: 'https://tsri.com/images/2021/04/16/cobol-illustration-01.png',
}];
